// markerHelpers.js

import { MapUtils } from '../utils_map/mapUtils'
import { offsetCenter } from './mapHelpers'
import { startLiveLocation, stopLiveLocation } from '../utils/locationUtils.js'

// Variable globale pour stocker l'ID du watcher
let userPositionWatcher = null

/**
 * Gestion des markers et de la position utilisateur
 */
export async function refreshUserPosition(markersArray) {
  try {
    // Utiliser la fonction avec fallback intelligent
    const pos = await MapUtils.getCurrentPositionWithFallback()
    if (!pos?.lat || !pos?.lng) return null

    const userMarker = {
      isUserPosition: true,
      position: { lat: pos.lat, lng: pos.lng },
      heading: pos.heading,
      speed: pos.speed,
      content: 'Votre position',
    }

    const idx = markersArray.findIndex(m => m.isUserPosition)
    if (idx !== -1) markersArray[idx] = userMarker
    else markersArray.push(userMarker)

    return userMarker.position
  } catch (error) {
    // Si même le fallback échoue, on ne peut rien faire
    console.warn(
      'Impossible de récupérer la position utilisateur (même avec fallback):',
      error instanceof Error ? error.message : String(error),
    )
    return null
  }
}

/**
 * Démarre le suivi en temps réel de la position utilisateur
 * @param {Array} markersArray - tableau des markers
 * @param {Function} onUpdate - callback optionnel pour les mises à jour
 */
export async function startRealTimeUserTracking(markersArray, onUpdate = null) {
  // Arrêter le suivi précédent s'il existe
  stopRealTimeUserTracking()

  userPositionWatcher = await startLiveLocation(
    positionData => {
      // Mettre à jour le marker utilisateur
      const userMarker = {
        isUserPosition: true,
        position: { lat: positionData.lat, lng: positionData.lng },
        heading: positionData.heading,
        speed: positionData.speed,
        content: 'Votre position',
      }

      const idx = markersArray.findIndex(m => m.isUserPosition)
      if (idx !== -1) markersArray[idx] = userMarker
      else markersArray.push(userMarker)

      // Appeler le callback de mise à jour si fourni
      if (onUpdate && typeof onUpdate === 'function') {
        onUpdate(userMarker)
      }
    },
    {
      enableHighAccuracy: true,
      timeout: 30000,
      maximumAge: 1000, // Accepter les positions de moins de 1 seconde
    },
  )

  return userPositionWatcher
}

/**
 * Arrête le suivi en temps réel de la position utilisateur
 */
export function stopRealTimeUserTracking() {
  if (userPositionWatcher) {
    stopLiveLocation(userPositionWatcher)
    userPositionWatcher = null
  }
}

export async function centerOnUser(map, markersArray, offsetY) {
  try {
    const userPos = await refreshUserPosition(markersArray)
    if (!userPos || !map) return
    map.panTo(offsetCenter(userPos, offsetY, map))
  } catch (error) {
    // Erreur de centrage sur l'utilisateur - gérable localement
    console.warn(
      'Impossible de centrer sur la position utilisateur:',
      error instanceof Error ? error.message : String(error),
    )
  }
}

export function addStepMarker(marker, markersArray, routeId = null) {
  markersArray.push({
    position: { lat: marker.lat, lng: marker.lng },
    isUserPosition: false,
    routeId,
    options: { title: marker.label || 'Étape' },
  })
}
